import React from 'react';
import { TbNotes } from 'react-icons/tb';

import { Icon, IconButton, Tooltip } from '../../core-ui';

type Props = {
  onPress: () => void;
};

export default function AttendanceTableNotesCell({ onPress }: Props) {
  return (
    <Tooltip label={t('Vendor Internal Notes')} placement="top">
      <IconButton
        variant="unstyled"
        size="xs"
        alignSelf="center"
        marginLeft={2}
        aria-label={t('Vendor Internal Notes')}
        icon={<Icon as={TbNotes} fontSize={24} />}
        onClick={() => onPress()}
      />
    </Tooltip>
  );
}
